import { ContainerHeadline } from "./styles";

export const Headline = () => {
  return (
    <ContainerHeadline>
      <h2>Crie sua conta</h2>
      <p>Rápido e grátis, vamos nessa</p>
    </ContainerHeadline>
  );
};
